var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngluarIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3232_9688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 3.975L11.919 0L23.382 3.9135L21.5295 18.684L11.919 24L2.4645 18.753L0.75 3.975Z",
    fill: "#E23237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3819 3.9135L11.9189 0V24L21.5294 18.684L23.3819 3.9135Z",
    fill: "#B52E31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9366 2.80499L4.97656 18.285L7.57381 18.2325L8.97631 14.7345H15.2013L16.7253 18.2595L19.2018 18.312L11.9366 2.80499ZM11.9538 7.77449L14.3088 12.6922H9.90031L11.9606 7.77449H11.9538Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3232_9688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngluarIcon1);
export default __webpack_public_path__ + "static/media/angluar-icon (1).e9fbca7b778ab943ab3b32bb4a043f63.svg";
export { ForwardRef as ReactComponent };